"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description 全局变量
 */
var _ = require("@antv/util");
// @ts-ignore
var pkg = require("../package.json");
var theme_1 = require("./theme");
var Global = {
    version: pkg.version,
    renderer: 'canvas',
    width: 640,
    height: 480,
    pixelRatio: null,
    animate: true,
    widthRatio: {
        // 宽度所占的分类的比例
        column: 1 / 2,
        rose: 0.9999999,
        multiplePie: 1 / 1.3,
    },
    theme: theme_1.getTheme('default'),
    setTheme: function (type) {
        var newTheme = {};
        if (_.isObject(type)) {
            newTheme = type;
        }
        else if (theme_1.getTheme(type)) {
            newTheme = theme_1.getTheme(type);
        }
        else {
            newTheme = theme_1.getTheme('default');
        }
        // @ts-ignore
        _.deepMix(Global.theme, newTheme);
    },
};
exports.default = Global;
exports.setTheme = Global.setTheme;
exports.version = Global.version;
//# sourceMappingURL=global.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/global.js
// module id = 309
// module chunks = 37